import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../services/api';

const AGREEMENT_VERSION = '1.0';

export default function Agreement() {
  const { user, refreshProfile } = useAuth();
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user?.platform_agreement_signed) {
    return (
      <div>
        <h2>Platform Agreement</h2>
        <div className="alert alert-success">
          You signed the platform agreement on {new Date(user.platform_agreement_date).toLocaleDateString()}.
          <br />Version: {user.platform_agreement_version}
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.acceptAgreement(AGREEMENT_VERSION);
      await refreshProfile();
      navigate('/');
    } catch (err) {
      alert('Error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>Platform Agreement</h2>
      <p>Please review and accept the platform agreement to begin licensing your inventory.</p>

      <div className="card">
        <div className="agreement-content">
          <h4>DMS Syndication Platform - Dealer Agreement</h4>
          <p><strong>Version {AGREEMENT_VERSION}</strong></p>

          <h5>1. Service Description</h5>
          <p>The DMS Syndication Platform ("Platform") provides vehicle inventory syndication and licensing services to automotive dealerships ("Dealer"). By accepting this agreement, Dealer agrees to make their vehicle inventory data available to licensed third-party partners ("Partners") through the Platform.</p>

          <h5>2. Revenue Sharing</h5>
          <p>Dealer will receive {user?.revenue_split_percentage || 70}% of all licensing fees collected from Partners for access to Dealer's inventory data. The Platform retains {100 - (user?.revenue_split_percentage || 70)}% as a service fee. Payments are processed monthly for the previous month's activity.</p>

          <h5>3. Data Ownership</h5>
          <p>Dealer retains full ownership of their vehicle inventory data. The Platform acts as a licensed distributor on behalf of the Dealer. Dealer may revoke syndication permissions at any time.</p>

          <h5>4. Dealer Responsibilities</h5>
          <ul>
            <li>Maintain accurate and up-to-date vehicle inventory information</li>
            <li>Ensure all data provided complies with applicable laws and regulations</li>
            <li>Not provide false, misleading, or fraudulent information</li>
            <li>Maintain valid business licenses and insurance</li>
          </ul>

          <h5>5. Platform Responsibilities</h5>
          <ul>
            <li>Securely store and transmit Dealer data</li>
            <li>Vet and monitor Partner usage</li>
            <li>Process payments accurately and on time</li>
            <li>Provide reporting and analytics</li>
          </ul>

          <h5>6. Termination</h5>
          <p>Either party may terminate this agreement with 30 days written notice. Upon termination, the Platform will cease distributing Dealer's inventory data to Partners within 24 hours.</p>

          <h5>7. Limitation of Liability</h5>
          <p>The Platform's liability is limited to fees collected on behalf of Dealer in the 12 months preceding any claim. The Platform is not liable for Partner misuse of data or consequential damages.</p>

          <h5>8. Governing Law</h5>
          <p>This agreement is governed by the laws of the State of Texas.</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="agreement-checkbox">
            <input
              type="checkbox"
              id="agree"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
            />
            <label htmlFor="agree">
              I have read and agree to the terms of this agreement
            </label>
          </div>

          <button type="submit" className="btn btn-success" disabled={!agreed || loading}>
            {loading ? 'Processing...' : 'Accept Agreement'}
          </button>
        </form>
      </div>
    </div>
  );
}
